module.exports = __webpack_public_path__ + "9b860f650cc4899ab2ca259aae2c3584.png";